var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.7708 31.3897C85.1613 30.9992 85.1613 30.366 84.7708 29.9755L80.0238 25.2286C79.6333 24.8381 79.0001 24.8381 78.6096 25.2286L54.9987 48.8395L31.3878 25.2286C30.9973 24.8381 30.3641 24.8381 29.9736 25.2286L25.2266 29.9755C24.8361 30.366 24.8361 30.9992 25.2266 31.3897L48.8376 55.0007L25.2266 78.6116C24.8361 79.0021 24.8361 79.6353 25.2266 80.0258L29.9736 84.7727C30.3641 85.1632 30.9973 85.1632 31.3878 84.7727L54.9987 61.1618L78.6096 84.7727C79.0001 85.1632 79.6333 85.1632 80.0238 84.7727L84.7708 80.0258C85.1613 79.6353 85.1613 79.0021 84.7708 78.6116L61.1598 55.0007L84.7708 31.3897Z",
    fill: "#FA4A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.18d9f55c.svg";
export { ForwardRef as ReactComponent };